import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IoCallOutline, IoLocationOutline, IoDownloadOutline, IoMenuOutline, IoCloseOutline } from "react-icons/io5";
import './Navbar.css';

const Navbar = () => {
  const [isCallHovered, setIsCallHovered] = useState(false);
  const [isLocationHovered, setIsLocationHovered] = useState(false);
  const [isDownloadHovered, setIsDownloadHovered] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="nav-wrapper">
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');
        `}
      </style>
      <nav className="navbar">
        <div className="left-section">
          <div className="logo-container">
            <Link to="/" className="logo-link">
              <img 
                src="\biyanis_symbol_lg -transparent.png" 
                alt="Biyanis Education Group" 
                className="logo" 
                loading="lazy"
              />
            </Link>
          </div>
          <div className="nav-links">
            <div className="dropdown-container">
              <Link to="/at-biyanis" className="nav-link">At Biyani's</Link>
            </div>
            <div className="dropdown-container">
              <Link to="/teachers-team" className="nav-link">Teachers Team</Link>
            </div>
            <div className="dropdown-container">
              <Link to="/dream90" className="nav-link">Dream 90</Link>
            </div>
            <div className="dropdown-container">
              <Link to="/branch-and-courses" className="nav-link">Branch and Courses</Link>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button 
            className="nav-button"
            onMouseEnter={() => setIsDownloadHovered(true)}
            onMouseLeave={() => setIsDownloadHovered(false)}
            onClick={() => {
              const link = document.createElement('a');
              link.href = '/Biyani\'s Super 30 Brochure.pdf';
              link.download = 'Biyani\'s Super 30 Brochure.pdf';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            <IoDownloadOutline className={`nav-icon ${isDownloadHovered ? 'hovered' : ''}`} />
          </button>
          <button 
            className="nav-button"
            onMouseEnter={() => setIsCallHovered(true)}
            onMouseLeave={() => setIsCallHovered(false)}
            onClick={() => window.location.href = 'tel:+919372734935'}
          >
            <IoCallOutline className={`nav-icon ${isCallHovered ? 'hovered' : ''}`} />
          </button>
          <Link to="/locations" className="nav-link nav-link-location">
            <button 
              className="nav-button"
              onMouseEnter={() => setIsLocationHovered(true)}
              onMouseLeave={() => setIsLocationHovered(false)}
            >
              <IoLocationOutline className={`nav-icon ${isLocationHovered ? 'hovered' : ''}`} />
            </button>
          </Link>
          <button 
            className="mobile-menu-button"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? <IoCloseOutline /> : <IoMenuOutline />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <button 
          className="mobile-menu-close"
          onClick={toggleMobileMenu}
          aria-label="Close mobile menu"
        >
          <IoCloseOutline />
        </button>
        <div className="mobile-menu-content">
          <Link to="/at-biyanis" className="mobile-nav-link" onClick={toggleMobileMenu}>At Biyani's</Link>
          <Link to="/teachers-team" className="mobile-nav-link" onClick={toggleMobileMenu}>Teachers Team</Link>
          <Link to="/dream90" className="mobile-nav-link" onClick={toggleMobileMenu}>Dream 90</Link>
          <Link to="/branch-and-courses" className="mobile-nav-link" onClick={toggleMobileMenu}>Branch and Courses</Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;